import { ignoreGDKErrors } from '@golden/sentry-vue'
import type { BrowserOptions } from '@golden/sentry-vue'
import { SENTRY_IGNORE_CODES } from '@/constants/sentryIgnoreCodes'
import { isPageScriptStackOverflow } from '@/utils/isPageScriptStackOverflow'

type BeforeSend = NonNullable<BrowserOptions['beforeSend']>

const ignoreGDK = ignoreGDKErrors(SENTRY_IGNORE_CODES)

export const beforeSend: BeforeSend = (event, hint) => {
  const kept = ignoreGDK(event, hint)
  if (kept === null) return null
  return isPageScriptStackOverflow(kept, window.location.origin) ? null : kept
}
